module.exports = __webpack_public_path__ + "static/media/mollo_5.763a7194.png";